
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 2800 1400"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#12ad2b","d":"M0 0h2800v1400H0z"}}),_c('path',{attrs:{"fill":"#ffce00","d":"M0 400h2800v600H0z"}}),_c('path',{attrs:{"d":"M0 0v1400l700-700","fill":"#d21034"}}),_c('g',{attrs:{"id":"c","transform":"translate(1400 700)","fill":"#000"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-200V0h100","transform":"rotate(18 0 -200)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(288)"}})]),_c('use',{attrs:{"xlink:href":"#c","x":"700"}})])
          )
        }
      }
    